export default __webpack_public_path__ + "static/media/pickup_curbside.7d1bad71.svg";